module.exports = __webpack_public_path__ + "static/logo-9a934e315b59a08523fdaa6840bd9da5.png";